import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 时间分段
 */
const timeSegments = {

  /**
   * 查询时间分段组
   */
  getTimeSegmentsGroup (companyId) {
    return axios.post(base.timeSegments.getTimeSegmentsGroup, utils.postParamsArrayToJsonString({ companyId }))
  },
  /**
   * 新增时间分段组
   */
  addTimeSegmentsGroup (companyId, name, displayName) {
    return axios.post(base.timeSegments.addTimeSegmentsGroup, utils.postParamsArrayToJsonString({ companyId, name, displayName }))
  },
  /**
   * 修改时间分段组
   */
  modifyTimeSegmentsGroup (groupId, name, displayName) {
    return axios.post(base.timeSegments.modifyTimeSegmentsGroup, utils.postParamsArrayToJsonString({ groupId, name, displayName }))
  },
  /**
   * 删除时间分段组
   */
  deleteTimeSegmentsGroup (groupId) {
    return axios.post(base.timeSegments.deleteTimeSegmentsGroup, utils.postParamsArrayToJsonString({ groupId }))
  },
  /**
   * 查询时间分段
   */
  getTimeSegments (groupId) {
    return axios.post(base.timeSegments.getTimeSegments, utils.postParamsArrayToJsonString({ groupId }))
  },
  /**
   * 新增时间分段
   */
  addTimeSegments (groupId, name, displayName) {
    return axios.post(base.timeSegments.addTimeSegments, utils.postParamsArrayToJsonString({ groupId, name, displayName }))
  },
  /**
   * 修改时间分段
   */
  modifyTimeSegments (segmentId, name, displayName) {
    return axios.post(base.timeSegments.modifyTimeSegments, utils.postParamsArrayToJsonString({ segmentId, name, displayName }))
  },
  /**
   * 删除时间分段
   */
  deleteTimeSegments (segmentId) {
    return axios.post(base.timeSegments.deleteTimeSegments, utils.postParamsArrayToJsonString({ segmentId }))
  },
  /**
   * 查询时间分段规律
   */
  getRhythmicsOfSegmentTime (segmentId) {
    return axios.post(base.timeSegments.getRhythmicsOfSegmentTime, utils.postParamsArrayToJsonString({ segmentId }))
  },
  /**
   * 新增时间分段规律
   */
  addRhythmicsOfSegmentTime (segmentId, startTime, endTime, dayLoop, weekLoop, monthLoop) {
    return axios.post(base.timeSegments.addRhythmicsOfSegmentTime, utils.postParamsArrayToJsonString({ segmentId, startTime, endTime, dayLoop, weekLoop, monthLoop }))
  },
  /**
   * 修改时间分段规律
   */
  modifyRhythmicsOfSegmentTime (rhythmicId, startTime, endTime, dayLoop, weekLoop, monthLoop) {
    return axios.post(base.timeSegments.modifyRhythmicsOfSegmentTime, utils.postParamsArrayToJsonString({ rhythmicId, startTime, endTime, dayLoop, weekLoop, monthLoop }))
  },
  /**
   * 删除时间分段规律表
   */
  deleteRhythmicsOfSegmentTime (rhythmicId) {
    return axios.post(base.timeSegments.deleteRhythmicsOfSegmentTime, utils.postParamsArrayToJsonString({ rhythmicId }))
  },
}

export default timeSegments